module.exports = __webpack_public_path__ + "img/EK Dant Card.c900737a.jpg";